import React, { useEffect, useState } from "react";
import {
  getProcessRequest,
  createProcessRequest,
  updateProcessRequest,
  deleteProcessRequest
} from "../../globalhelper/helper";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import {
  Paper,
  Grid,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  IconButton
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

const ProcessList = () => {

  const history = useHistory();

  const [selectedProcessCd, setSelectedProcessCd] =
    useState("");

  const [processCodes, setProcessCodes] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [hasSearched, setHasSearched] =
    useState(false);

  const [tableData, setTableData] =
    useState([]);

  const [originalRow, setOriginalRow] =
    useState(null);

  const [page, setPage] =
    useState(0);

  const [rowsPerPage, setRowsPerPage] =
    useState(10);

  const [isAdding, setIsAdding] =
    useState(false);

  const [newRow, setNewRow] =
    useState({});

  const [editRowId, setEditRowId] =
    useState(null);

  const [editedRow, setEditedRow] =
    useState({});

  const [deleteOpen, setDeleteOpen] =
    useState(false);

  const [deleteRow, setDeleteRow] =
    useState(null);

  const getProcessCdList = async () => {

    try {

      const result =
        await getProcessRequest(
          "api/process/getProcessCdList"
        );

      const data =
        result?.data?.data || [];

      setProcessCodes(data);

    } catch (error) {

      console.log(
        "ERROR:",
        error
      );
    }
  };


  const getProcessByCode = async (
    processCd
  ) => {

    try {

      setLoading(true);

      const result =
        await getProcessRequest(
          `api/process/getProcessByCode/${processCd}`
        );

      const data =
        result?.data?.data || [];

      setTableData(data);
      setPage(0);
      setHasSearched(true);

    } catch (error) {

      console.log(
        "ERROR:",
        error
      );

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {
    getProcessCdList();
  }, []);


  const paginatedData = tableData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (
    event,
    newPage
  ) => {

    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event
  ) => {

    setRowsPerPage(
      parseInt(
        event.target.value,
        10
      )
    );

    setPage(0);
  };

  const handleEdit = (row) => {

    setEditRowId(
      `${row.process_cd}_${row.short_text}`
    );

    setOriginalRow({
      process_cd: row.process_cd,
      short_text: row.short_text
    });

    setEditedRow({
      ...row
    });

  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedRow({});
  };

  const handleFieldChange = (
    field,
    value
  ) => {

    setEditedRow((prev) => {

      const updatedRow = {
        ...prev,
        [field]: value
      };

      if (
        field === "short_text" ||
        field === "process_cd"
      ) {

        const processCd =
          field === "process_cd"
            ? value.trim()
            : updatedRow.process_cd?.trim();

        const shortText =
          field === "short_text"
            ? value.trim()
            : updatedRow.short_text?.trim();

        updatedRow.domain =
          shortText || "";

        // GENERATED VALUE
        const generatedValue =
          processCd && shortText
            ? `${processCd}_${shortText}`
            : "";

        updatedRow.name = generatedValue;
        updatedRow.label = generatedValue;
        updatedRow.acronym = generatedValue;
      }

      return updatedRow;
    });
  };


  const handleSave = async (row) => {

    try {

      const duplicateExists = tableData.some((item) => {

        // skip current editing row
        const isCurrentRow =

          item.process_cd === originalRow.process_cd &&
          item.short_text === originalRow.short_text;

        if (isCurrentRow) {
          return false;
        }

        return (

          item.product_cd === row.product_cd &&
          item.process_cd === row.process_cd &&
          item.short_text?.toLowerCase().trim() ===
          row.short_text?.toLowerCase().trim()

        );

      });

      if (duplicateExists) {

        alert(
          "Short Text already exists for this Process Code"
        );

        return;
      }

      const result =
        await updateProcessRequest(

          `api/process/updateProcess/${originalRow.process_cd}/${originalRow.short_text}`,

          row
        );

      console.log(
        "UPDATED:",
        result
      );

      setTableData((prev) =>

        prev.map((item) =>

          item.process_cd === originalRow.process_cd &&
            item.short_text === originalRow.short_text

            ? row
            : item
        )
      );

      setEditRowId(null);
      setEditedRow({});
      setOriginalRow(null);

    } catch (error) {

      console.log(error);

      alert(
        error?.response?.data?.message ||
        "Update Failed"
      );
    }
  };


  const handleDelete = async () => {

    if (!deleteRow) return;

    try {

      console.log(
        "DELETE API:",
        deleteRow
      );

      await deleteProcessRequest(

        `api/process/deleteProcess/${deleteRow.process_cd}/${deleteRow.short_text}`
      );

      const filtered =
        tableData.filter(
          (item) =>
            !(
              item.process_cd === deleteRow.process_cd &&
              item.short_text === deleteRow.short_text
            )
        );

      setTableData(filtered);

      toast.success(
        "Process Deleted Successfully"
      );

    } catch (error) {

      console.log(error);

      toast.error(
        "Delete Failed"
      );

    } finally {

      setDeleteOpen(false);

      setDeleteRow(null);
    }
  };

  const handleAddRow = () => {

    const selectedProcess =
      processCodes.find(
        (item) =>
          item.process_cd ===
          selectedProcessCd
      );

    setNewRow({
      process_cd:
        selectedProcessCd,
      process_name:
        selectedProcess?.process_name ||
        "",
      short_text: "",
      domain: "",
      name: "",
      label: "",
      data_type: "VARCHAR",
      default_value: "",
      lde: 0,
      indexing: 0,
      mandatory: "",
      derive_formula: "",
      predefined_list: "",
      acronym: ""
    });

    setIsAdding(true);
  };

  const handleNewRowChange = (
    field,
    value
  ) => {

    setNewRow((prev) => {

      const updatedRow = {
        ...prev,
        [field]: value
      };

      if (
        field === "short_text" ||
        field === "process_cd"
      ) {

        const processCd =
          field === "process_cd"
            ? value.trim()
            : updatedRow.process_cd?.trim();

        const shortText =
          field === "short_text"
            ? value.trim()
            : updatedRow.short_text?.trim();

        updatedRow.domain =
          shortText || "";

        const generatedValue =
          processCd && shortText
            ? `${processCd}_${shortText}`
            : "";

        updatedRow.name =
          generatedValue;

        updatedRow.label =
          generatedValue;

        updatedRow.acronym =
          generatedValue;
      }

      return updatedRow;
    });
  };

  const handleSaveNewRow = async () => {

    if (!newRow.short_text?.trim()) {

      toast.error(
        "Short Text is required"
      );

      return;
    }

    try {

      console.log(
        "NEW ROW:",
        newRow
      );

      const result =
        await createProcessRequest(
          "api/process/createProcess",
          newRow
        );

      console.log(
        "CREATED:",
        result
      );

      if (result.type === "failed") {

        toast.error(
          result?.data?.message ||
          "Failed to create process"
        );

        return;
      }


      if (result.type === "success") {

        setTableData((prev) => [
          ...prev,
          result.data.data
        ]);

        toast.success(
          result.data.message ||
          "Process Created"
        );

        setIsAdding(false);

        setNewRow({});
      }

    } catch (error) {

      console.log(error);

      toast.error(
        error?.response?.data?.message ||
        "Failed to create process"
      );
    }
  };

  const handleCancelNewRow = () => {

    setIsAdding(false);

    setNewRow({});
  };

  return (

    <Paper
      elevation={3}
      sx={{
        padding: "25px",
        margin: "20px"
      }}
    >

      {/* HEADER */}

      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginBottom: "25px"
        }}
      >

        <Grid item>

          <Typography variant="h5">
            Process Management
          </Typography>

        </Grid>

        <Grid item>

          <Button
            variant="contained"
            onClick={() => history.push("/process/create")}
          >
            + Create New Process
          </Button>

        </Grid>

      </Grid>

      {/* FILTER */}

      <Paper
        elevation={2}
        sx={{
          padding: "20px",
          marginBottom: "25px"
        }}
      >

        <Grid container spacing={3}>

          <Grid item xs={12} md={4}>

            <FormControl fullWidth>

              <InputLabel>
                Process Code
              </InputLabel>

              <Select
                value={selectedProcessCd}
                label="Process Code"
                onChange={(e) => {
                  setSelectedProcessCd(
                    e.target.value
                  );
                }}
              >

                {processCodes.map(
                  (item) => (

                    <MenuItem
                      key={
                        item.process_cd
                      }
                      value={
                        item.process_cd
                      }
                    >
                      {
                        item.display_name
                      }
                    </MenuItem>
                  )
                )}

              </Select>

            </FormControl>

          </Grid>

          <Grid item xs={12} md={2}>

            <Button
              fullWidth
              variant="contained"
              sx={{
                height: "56px"
              }}
              disabled={
                !selectedProcessCd ||
                loading
              }
              onClick={() =>
                getProcessByCode(
                  selectedProcessCd
                )
              }
            >

              {loading
                ? "Searching..."
                : "Search"}

            </Button>

          </Grid>

        </Grid>

      </Paper>

      {/* TABLE */}

      <Paper elevation={2}>

        <div
          style={{
            width: "100%",
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "600px"
          }}
        >

          <TableContainer>

            <Table
              stickyHeader
              sx={{
                minWidth: "1600px"
              }}
            >

              <TableHead>

                <TableRow>

                  <TableCell>
                    Process Code
                  </TableCell>

                  <TableCell>
                    Process Name
                  </TableCell>

                  <TableCell>
                    Short Text
                  </TableCell>

                  <TableCell>
                    Data Type
                  </TableCell>

                  <TableCell>
                    Default Value
                  </TableCell>

                  <TableCell>
                    Mandatory
                  </TableCell>

                  <TableCell>
                    Action
                  </TableCell>

                </TableRow>

              </TableHead>

              <TableBody>

                {!selectedProcessCd ? (

                  <TableRow>

                    <TableCell
                      colSpan={7}
                      align="center"
                    >
                      Please Select Process Code
                    </TableCell>

                  </TableRow>

                ) : loading ? (

                  <TableRow>

                    <TableCell
                      colSpan={7}
                      align="center"
                    >
                      Fetching Process Data...
                    </TableCell>

                  </TableRow>

                ) : (

                  <>

                    {paginatedData.length > 0 ? (

                      paginatedData.map((row) => {

                        const isEditing =
                          editRowId ===
                          `${row.process_cd}_${row.short_text}`;

                        return (

                          <TableRow
                            key={`${row.process_cd}_${row.short_text}`}
                          >

                            {/* PROCESS CODE */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.process_cd ??
                                    row.process_cd
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "process_cd",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.process_cd

                              )}

                            </TableCell>

                            {/* PROCESS NAME */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.process_name ??
                                    row.process_name
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "process_name",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.process_name

                              )}

                            </TableCell>

                            {/* SHORT TEXT */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.short_text ??
                                    row.short_text
                                  }
                                  error={
                                    !(editedRow.short_text ?? row.short_text)?.trim()
                                  }
                                  helperText={
                                    !(editedRow.short_text ?? row.short_text)?.trim()
                                      ? "Short text is required"
                                      : ""
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "short_text",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.short_text

                              )}

                            </TableCell>

                            {/* DATA TYPE */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.data_type ??
                                    row.data_type
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "data_type",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.data_type

                              )}

                            </TableCell>

                            {/* DEFAULT VALUE */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.default_value ??
                                    row.default_value ??
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "default_value",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.default_value

                              )}

                            </TableCell>

                            {/* MANDATORY */}

                            <TableCell>

                              {isEditing ? (

                                <TextField
                                  size="small"
                                  value={
                                    editedRow.mandatory ??
                                    row.mandatory ??
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleFieldChange(
                                      "mandatory",
                                      e.target.value
                                    )
                                  }
                                />

                              ) : (

                                row.mandatory

                              )}

                            </TableCell>

                            {/* ACTION */}

                            <TableCell>

                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px"
                                }}
                              >

                                {isEditing ? (

                                  <>

                                    <IconButton
                                      color="success"
                                      onClick={() =>
                                        handleSave({
                                          ...row,
                                          ...editedRow
                                        })
                                      }
                                    >
                                      <SaveIcon />
                                    </IconButton>

                                    <IconButton
                                      color="secondary"
                                      onClick={
                                        handleCancel
                                      }
                                    >
                                      <CloseIcon />
                                    </IconButton>

                                  </>

                                ) : (

                                  <>

                                    <IconButton
                                      color="primary"
                                      onClick={() =>
                                        handleEdit(row)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>

                                    <IconButton
                                      color="error"
                                      onClick={() => {
                                        setDeleteRow(row);
                                        setDeleteOpen(true);
                                      }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>

                                  </>

                                )}

                              </div>

                            </TableCell>

                          </TableRow>

                        );
                      })

                    ) : hasSearched ? (

                      <TableRow>

                        <TableCell
                          colSpan={7}
                          align="center"
                        >
                          No Records Found
                        </TableCell>

                      </TableRow>

                    ) : null}

                    {/* ========================= */}
                    {/* ADD NEW ROW */}
                    {/* ========================= */}

                    {isAdding && (

                      <TableRow>

                        <TableCell>
                          {newRow.process_cd}
                        </TableCell>

                        <TableCell>
                          {newRow.process_name}
                        </TableCell>

                        <TableCell>

                          <TextField
                            required
                            size="small"
                            value={newRow.short_text}
                            error={!newRow.short_text?.trim()}
                            helperText={
                              !newRow.short_text?.trim()
                                ? "Short text is required"
                                : ""
                            }
                            onChange={(e) =>
                              handleNewRowChange(
                                "short_text",
                                e.target.value
                              )
                            }
                            sx={{
                              minWidth: "180px"
                            }}
                          />

                        </TableCell>

                        <TableCell>

                          <TextField
                            size="small"
                            value={newRow.data_type}
                            onChange={(e) =>
                              handleNewRowChange(
                                "data_type",
                                e.target.value
                              )
                            }
                          />

                        </TableCell>

                        <TableCell>

                          <TextField
                            size="small"
                            value={newRow.default_value}
                            onChange={(e) =>
                              handleNewRowChange(
                                "default_value",
                                e.target.value
                              )
                            }
                          />

                        </TableCell>

                        <TableCell>

                          <TextField
                            size="small"
                            value={newRow.mandatory}
                            onChange={(e) =>
                              handleNewRowChange(
                                "mandatory",
                                e.target.value
                              )
                            }
                          />

                        </TableCell>

                        <TableCell>

                          <div
                            style={{
                              display: "flex",
                              gap: "5px"
                            }}
                          >

                            <IconButton
                              color="success"
                              onClick={
                                handleSaveNewRow
                              }
                            >
                              <SaveIcon />
                            </IconButton>

                            <IconButton
                              color="secondary"
                              onClick={
                                handleCancelNewRow
                              }
                            >
                              <CloseIcon />
                            </IconButton>

                          </div>

                        </TableCell>

                      </TableRow>

                    )}

                  </>

                )}

              </TableBody>

            </Table>

          </TableContainer>

          <div
            style={{
              padding: "15px",
              display: "flex",
              justifyContent: "flex-end"
            }}
          >

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              disabled={
                !selectedProcessCd ||
                isAdding
              }
              onClick={handleAddRow}
            >
              Add Row
            </Button>

          </div>

          {/* PAGINATION */}

          {tableData.length > 0 && (

            <TablePagination
              component="div"
              count={tableData.length}
              page={page}
              onPageChange={
                handleChangePage
              }
              rowsPerPage={
                rowsPerPage
              }
              onRowsPerPageChange={
                handleChangeRowsPerPage
              }
              rowsPerPageOptions={[
                5,
                10,
                25,
                50
              ]}
            />

          )}

        </div>

        <Dialog
          open={deleteOpen}
          onClose={() =>
            setDeleteOpen(false)
          }
          PaperProps={{
            sx: {
              width: "420px",
              borderRadius: "18px",
              padding: "10px"
            }
          }}
        >

          <DialogTitle
            sx={{
              fontSize: "30px",
              fontWeight: 600,
              paddingBottom: "10px"
            }}
          >
            Confirm Delete
          </DialogTitle>

          <DialogContent
            sx={{
              paddingTop: "0px !important"
            }}
          >

            <DialogContentText
              sx={{
                fontSize: "16px"
              }}
            >
              Are you sure you want to delete

              <b>
                {" "}
                {deleteRow?.short_text}
              </b>
              ?

            </DialogContentText>

          </DialogContent>

          <DialogActions
            sx={{
              padding: "18px 24px 20px"
            }}
          >

            <Button
              onClick={() =>
                setDeleteOpen(false)
              }
              sx={{
                textTransform: "none"
              }}
            >
              Cancel
            </Button>

            <Button
              color="error"
              variant="contained"
              onClick={handleDelete}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                padding: "8px 22px"
              }}
            >
              Delete
            </Button>

          </DialogActions>

        </Dialog>

      </Paper>

    </Paper>
  );
};

export default ProcessList;